import React from "react"
import types from "prop-types"
import MassSelection from "shared/MassSelection"
import ColumnOption from "ReportBuilder/ColumnOption"
import { reportExportBuilderColumnShape } from "utils/propTypeShapes"

const ColumnOptionsSection = ({
  deselectAll,
  deselectOption,
  options,
  selectAll,
  selectedColumns,
  selectOption,
  title,
}) => (
  <div>
    <div className="mb-1 text-xl">{title}</div>
    <MassSelection
      deselectAll={deselectAll}
      selectAll={selectAll}
    />
    <div className="w-full mt-4 space-y-2">
      {
        options.map((option) => (
          <ColumnOption
            key={`${option.type}-${option.id}`}
            option={option}
            selectedColumns={selectedColumns}
            selectOption={selectOption}
            deselectOption={deselectOption}
          />
        ))
      }
    </div>
  </div>
)

ColumnOptionsSection.propTypes = {
  deselectAll: types.func.isRequired,
  deselectOption: types.func.isRequired,
  options: types.arrayOf(reportExportBuilderColumnShape).isRequired,
  selectAll: types.func.isRequired,
  selectedColumns: types.arrayOf(reportExportBuilderColumnShape).isRequired,
  selectOption: types.func.isRequired,
  title: types.string.isRequired,
}

export default ColumnOptionsSection
